const Component = ({ config, onChange }) => {
  const isEvaluationDisabled = !!(config && config.isEvaluationDisabled);

  const toggleEvaluationDisabled = () => {
    onChange({ ...(config || {}), isEvaluationDisabled: !isEvaluationDisabled });
  };

  return (
    <table className="config-table">
      <thead>
        <tr>
          <th>Feature</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr className={isEvaluationDisabled ? "warn" : ""}>
          <td>Disable direct purchase evaluation</td>
          <td>
            <input
              type="checkbox"
              checked={isEvaluationDisabled}
              onChange={toggleEvaluationDisabled}
            />
            &nbsp;
            {isEvaluationDisabled
              ? "Evaluation disabled (direct purchase transactions are ignored)"
              : "Evaluation enabled"}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default Component;
